import Swiper from "swiper";
import "swiper/css";
const swipers = Array.from(document.querySelectorAll('.swiper'));
swipers.forEach((swiper) => {
    const swiperSlides = Array.from(swiper.querySelectorAll('.swiper-slide'));
    const initialSlide = swiperSlides.indexOf(swiperSlides.find((slide) => slide.classList.contains('btn-primary')));
    new Swiper(swiper, {
        initialSlide: initialSlide,
        spaceBetween: 18,
        freeMode: true,
        breakpoints: {
            1024: {
                slidesPerView: 5,
            },
            768: {
                slidesPerView: 3.5,
            },
            640: {
                slidesPerView: 2.5,
            },
            375: {
                slidesPerView: 1.5,
            }
        },
    });
});
